/**
 * RationaleEditor — small inline textarea + Save/Cancel.
 *
 * Ported from the legacy `Results/UNR155ChecklistSection.jsx`. Chrome
 * is fully token-driven so the editor reads correctly on top of the
 * Notion-style item-row background (--color-bg-secondary).
 *
 * Stateless to the caller — receives `current`, calls `onSave(next)`
 * with the trimmed value or `onCancel()`.
 */
import React, { useState } from 'react';
import styles from './UNR155Tree.module.css';

const RationaleEditor = ({ current, onSave, onCancel }) => {
  const [value, setValue] = useState(current ?? '');

  return (
    <div className={styles.rationaleEditor}>
      <textarea
        className={styles.rationaleTextarea}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Enter rationale for this relevance decision…"
        rows={3}
        autoFocus
      />
      <div className={styles.rationaleEditorActions}>
        <button type="button" className={styles.rationaleCancelBtn} onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className={styles.rationaleSaveBtn}
          onClick={() => onSave(value.trim())}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default RationaleEditor;
